import { render, staticRenderFns } from "./messageInfo.vue?vue&type=template&id=c70228aa&scoped=true&"
import script from "./messageInfo.vue?vue&type=script&lang=js&"
export * from "./messageInfo.vue?vue&type=script&lang=js&"
import style0 from "./messageInfo.vue?vue&type=style&index=0&id=c70228aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70228aa",
  null
  
)

export default component.exports